import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { myInvitationsQueryOptions } from "@/app/invitations/api/get-my-invitations";
import { InvitationsList } from "@/app/invitations/list";

const searchSchema = z.object({
  projectId: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/orgs/$organizationId/projects/$projectId/invitations/"
)({
  validateSearch: searchSchema,
  beforeLoad: ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(myInvitationsQueryOptions);
  },
  loader: () => ({
    crumb: "Invitations",
  }),
  component: InvitationsIndexRouteComponent,
});

function InvitationsIndexRouteComponent() {
  const search = Route.useSearch();
  return <InvitationsList projectId={search.projectId} />;
}
